import { render, staticRenderFns } from "./ComplementarEmpresa.vue?vue&type=template&id=d4ada8a0&"
import script from "./ComplementarEmpresa.vue?vue&type=script&lang=js&"
export * from "./ComplementarEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports